"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SFMemorial = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var SFMemorial = (function (_super) {
    __extends(SFMemorial, _super);
    function SFMemorial() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.SF_MEMORIAL,
            tags: [Tags_1.Tags.BUILDING],
            cost: 7,
            metadata: {
                cardNumber: 'P41',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.cards(1); }),
                description: 'Draw 1 card.',
                victoryPoints: 1,
            },
        }) || this;
    }
    SFMemorial.prototype.play = function (player) {
        player.drawCard();
        return undefined;
    };
    SFMemorial.prototype.getVictoryPoints = function () {
        return 1;
    };
    return SFMemorial;
}(Card_1.Card));
exports.SFMemorial = SFMemorial;
//# sourceMappingURL=SFMemorial.js.map